import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import AllStateContext from "../../context/allstateContext";
import { getAccountList, getCategoryList } from "../Apis/apis";
import { IS_DIALOG_ACCOUNT_CATEGORY_TYPE } from "../../Constant/constant";
import AddNewCategoryDialog from "../../Common/AddNewCategoryDialog";
import AddNewAccountDialog from "../../Common/AddNewAccountDialog";
const AccountDialog = () => {
  const {
    openAccount,
    setOpenAccount,
    selectedAccount,
    setSelectedAccount,
    selectedCategory,
    setSelectedCategory,
    transactionType,
    setTransactionType,
    isAccountOrCategoryDialog,
    setIsAccountOrCategoryDialog,
    setOpenAddNewCategoryDialog,
    setAddNewAccountDialog,
    addNewAccountDialog,
    openAddNewCategoryDialog,
  } = useContext(AllStateContext);

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch data from API when the dialog opens

  const getData = async () => {
    try {
      if (
        isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT
      ) {
        const response = await getAccountList();
        setData(response.data);
      } else {
        const filter = { type: transactionType };
        const response = await getCategoryList(filter);
        setData(response.data);
      }
    } catch (err) {}
  };
  useEffect(() => {
    getData();
  }, []);

  const onclickItem = (item) => {
    if (isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT) {
      setSelectedAccount({
        name: item.name,
        accountId: item.accountId,
        icon: item?.iconDetail?.icon,
      });
      setOpenAccount(false);
    } else {
      setSelectedCategory({
        name: item.name,
        categoryId: item.categoryId,
        icon: item?.iconDetail?.icon,
      });
      setOpenAccount(false);
    }
  };
  const newAddClick = () => {
    if (isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT) {
      setAddNewAccountDialog(true);
    } else {
      setOpenAddNewCategoryDialog(true);
    }
  };

  return (
    <>
      {addNewAccountDialog && <AddNewAccountDialog refetch={getData} />}
      {openAddNewCategoryDialog && <AddNewCategoryDialog refetch={getData} />}
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"lg"}
          open={openAccount}
          // onClose={() => setOpenAccount(false)}
        >
          <DialogTitle>
            {isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT
              ? "Select Account"
              : "Select Category"}
          </DialogTitle>
          <DialogContent>
            <div className="mb-2">
              <input
                type="text"
                placeholder={
                  isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT
                    ? "Search account..."
                    : "Search category..."
                }
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control"
                style={{
                  width: "100%",
                  fontSize: "0.9rem",
                  padding: "10px 16px",
                  marginBottom: "8px"
                }}
              />
            </div>
            <div className="grid-container">
              {data?.payload?.data
                ?.filter((item) => 
                  item?.name?.toLowerCase().includes(searchTerm.toLowerCase())
                )
                ?.map((item) => (
                <div 
                  key={item.accountId || item.categoryId || item.id} 
                  className="grid-item"
                  onClick={() => onclickItem(item)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          background: "rgba(255, 255, 255, 0.03)",
                          border: "1px solid rgba(255, 255, 255, 0.06)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <img
                          style={{ height: "22px", width: "22px" }}
                          src={item?.iconDetail?.icon}
                          alt={item?.name}
                        />
                      </div>
                      <span style={{ fontWeight: "600", fontSize: "0.95rem" }}>{item.name}</span>
                    </div>
                    {isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT && (
                      <div 
                        style={{ 
                          fontWeight: "700", 
                          fontSize: "0.95rem",
                          color: item?.balance < 0 ? "var(--danger)" : "var(--success)" 
                        }}
                      >
                        {item?.balance < 0
                          ? `-₹${Math.abs(item.balance).toLocaleString("en-IN")}`
                          : `₹${item.balance.toLocaleString("en-IN")}`}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div style={{ justifyContent: "center", display: "flex", marginTop: "24px" }}>
              <button
                type="button"
                className="btn btn-outline-primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px 20px",
                  fontSize: "0.88rem",
                  fontWeight: "600",
                  height: "38px",
                  borderRadius: "10px"
                }}
                onClick={() => {
                  newAddClick();
                }}
              >
                <img
                  style={{ width: "16px", height: "16px", filter: "invert(1)" }}
                  src={require("../../Common/Icon/plus.png")}
                  alt="plus"
                />
                {isAccountOrCategoryDialog === IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT
                  ? "Add New Account"
                  : "Add New Category"}
              </button>
            </div>
          </DialogContent>
          <DialogActions>
            <button className="btn btn-secondary" onClick={() => setOpenAccount(false)}>
              Close
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default AccountDialog;
